import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Contact from "./Contact";

const ROTATING = ['Prosperity', 'Legacy', 'Excellence', 'Growth'];
const STATS = [
    { num: '150+', label: 'Properties Managed' },
    { num: '12+',  label: 'Years in UAE' },
    { num: '98%',  label: 'Client Satisfaction' },
    { num: '15+',  label: 'Developer Partners' },
];
const SERVICES_PREVIEW = [
    { n:'01', title:'Property Sales',      desc:'Expert guidance from valuation to final handover.',        tags:['Residential','Commercial','Off-plan'] },
    { n:'02', title:'Property Leasing',    desc:'Connecting quality tenants with premium UAE properties.',  tags:['Short-term','Long-term','Corporate'] },
    { n:'03', title:'Property Management', desc:'Full-service management maximising occupancy & income.',   tags:['Maintenance','Tenant Relations'] },
    { n:'04', title:'Investment Advisory', desc:'Market-intelligence driven advice for high-yield assets.',  tags:['Portfolio','ROI Analysis'] },
    { n:'05', title:'Valuation Services',  desc:'RERA-compliant valuations for any property purpose.',      tags:['Certified','Detailed Reports'] },
    { n:'06', title:'Legal & Documentation',desc:'Fully compliant UAE documentation for every transaction.',tags:['Contracts','NOC Processing'] },
];
// ValuesPreview.tsx or inside About.tsx

// const VALUES_PREVIEW = [
//     {
//         title: "Innovation",
//         desc: "We build modern, scalable and creative digital solutions.",
//         icon: "⚡"
//     },
//     {
//         title: "Trust",
//         desc: "We maintain transparency and long-term client relationships.",
//         icon: "🤝"
//     },
//     {
//         title: "Quality",
//         desc: "We deliver high-performance and production-ready systems.",
//         icon: "🏆"
//     },
//     {
//         title: "Support",
//         desc: "We provide continuous support and system improvements.",
//         icon: "💡"
//     }
// ];
const PARTNERS = ['Emaar','DAMAC','Nakheel','Aldar','Meraas','Select Group','Dubai Properties','Union Properties'];
const PROPS_FEATURED = [
    { title:'Signature Villa',         loc:'Emirates Hills',      price:'AED 22,000,000', beds:6, baths:7, area:'9,500', type:'sale', tag:'Prime' },
    { title:'Sky Collection Residence',loc:'Dubai Creek Harbour', price:'AED 3,800,000',  beds:2, baths:2, area:'1,900', type:'sale' },
    { title:'Luxury Penthouse',        loc:'Dubai Marina',        price:'AED 45,000/mo',  beds:4, baths:4, area:'4,200', type:'rent', tag:'Featured' },
    { title:'Modern Villa',            loc:'Palm Jumeirah',       price:'AED 28,000/mo',  beds:5, baths:6, area:'6,800', type:'rent' },
];

const Hero: React.FC = () => {
    const [wordIdx,  setWordIdx]  = useState(0);
    const [fade,     setFade]     = useState(true);
    const [mousePos, setMousePos] = useState({ x: 50, y: 50 });
    const [propTab,  setPropTab]  = useState<'sale'|'rent'>('sale');
    const heroRef  = useRef<HTMLElement>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const id = setInterval(() => {
            setFade(false);
            setTimeout(() => { setWordIdx(i => (i + 1) % ROTATING.length); setFade(true); }, 500);
        }, 3400);
        return () => clearInterval(id);
    }, []);

    useEffect(() => {
        const onMove = (e: MouseEvent) => {
            if (!heroRef.current) return;
            const r = heroRef.current.getBoundingClientRect();
            setMousePos({ x: ((e.clientX - r.left) / r.width) * 100, y: ((e.clientY - r.top) / r.height) * 100 });
        };
        window.addEventListener('mousemove', onMove, { passive: true });
        return () => window.removeEventListener('mousemove', onMove);
    }, []);

    const go = (path: string) => { navigate(path); window.scrollTo({ top: 0, behavior: 'smooth' }); };
    const filteredProps = PROPS_FEATURED.filter(p => p.type === propTab);

    return (
        <>
            <style>{`
        /* ══════════════════════════════════
           HERO BANNER
        ══════════════════════════════════ */
        .hero{position:relative;min-height:100vh;display:grid;grid-template-rows:1fr auto;overflow:hidden;background:#030024}
        .hero-canvas{position:absolute;inset:0;z-index:0;overflow:hidden}
        .hero-base{position:absolute;inset:0;background:linear-gradient(155deg,#020018 0%,#040030 45%,#06003a 100%)}
        .hero-orb1{position:absolute;width:min(700px,100vw);height:min(700px,100vw);border-radius:50%;
          background:radial-gradient(circle,rgba(102,172,161,0.13) 0%,transparent 65%);
          top:-10%;left:-8%;transition:transform 1.8s cubic-bezier(.25,.1,.25,1);pointer-events:none}
        .hero-orb2{position:absolute;width:min(500px,80vw);height:min(500px,80vw);border-radius:50%;
          background:radial-gradient(circle,rgba(240,194,119,0.09) 0%,transparent 65%);
          right:-80px;bottom:0;transition:transform 2.4s cubic-bezier(.25,.1,.25,1);pointer-events:none}
        .hero-grid{position:absolute;inset:0;
          background-image:linear-gradient(rgba(102,172,161,.06) 1px,transparent 1px),
            linear-gradient(90deg,rgba(102,172,161,.06) 1px,transparent 1px);
          background-size:72px 72px;
          mask-image:radial-gradient(ellipse 80% 80% at 50% 50%,black 40%,transparent 100%);
          -webkit-mask-image:radial-gradient(ellipse 80% 80% at 50% 50%,black 40%,transparent 100%)}
        .hero-diag{position:absolute;top:-10%;right:22%;width:1px;height:130%;
          background:linear-gradient(180deg,transparent,rgba(240,194,119,.18) 30%,rgba(240,194,119,.18) 70%,transparent);
          transform:rotate(-18deg);transform-origin:top center}
        .hero-diag2{position:absolute;top:-10%;right:20%;width:1px;height:130%;
          background:linear-gradient(180deg,transparent,rgba(102,172,161,.07) 30%,rgba(102,172,161,.07) 70%,transparent);
          transform:rotate(-18deg);transform-origin:top center}

        .hero-body{position:relative;z-index:2;display:grid;grid-template-columns:1fr 390px;
          gap:4rem;align-items:center;padding:9rem 5rem 5rem;max-width:1320px;margin:0 auto;width:100%}
        .h-eyebrow{display:flex;align-items:center;gap:1.2rem;margin-bottom:2.6rem;
          opacity:0;animation:hUp .9s .1s ease forwards}
        .h-ey-line{width:40px;height:1px;background:#F0C277;flex-shrink:0}
        .h-ey-t1{font-family:'Tenor Sans',sans-serif;font-size:.62rem;letter-spacing:.45em;text-transform:uppercase;color:#F0C277}
        .h-ey-dot{width:4px;height:4px;border-radius:50%;background:rgba(240,194,119,.45)}
        .h-ey-t2{font-family:'Tenor Sans',sans-serif;font-size:.62rem;letter-spacing:.35em;text-transform:uppercase;color:rgba(248,245,239,.3)}
        .h-heading{opacity:0;animation:hUp 1s .25s ease forwards}
        .h-h1{font-family:'Cormorant Garamond',Georgia,serif;font-size:clamp(3rem,6.2vw,5.8rem);font-weight:400;line-height:1.06;letter-spacing:-.02em;color:#F8F5EF;margin:0}
        .h-h1-row2{display:flex;align-items:baseline;gap:.5rem;flex-wrap:wrap}
        .h-static{color:rgba(248,245,239,.82);font-weight:300}
        .h-rotating{display:inline-block;font-style:italic;font-weight:600;color:#F0C277;transition:opacity .5s ease,transform .5s ease;position:relative}
        .h-rotating::after{content:'';position:absolute;bottom:4px;left:0;right:0;height:2px;background:linear-gradient(90deg,#F0C277,transparent);opacity:.5}
        .h-tagline{font-family:'Cormorant Garamond',Georgia,serif;font-size:1.05rem;font-style:italic;font-weight:300;color:rgba(248,245,239,.28);margin-top:1.2rem;opacity:0;animation:hUp .9s .4s ease forwards}
        .h-sub{font-family:'Montserrat',sans-serif;font-size:1rem;font-weight:400;line-height:1.9;color:rgba(248,245,239,.72);max-width:480px;margin:2.2rem 0 2.8rem;opacity:0;animation:hUp .9s .5s ease forwards}
        .h-btns{display:flex;gap:1rem;flex-wrap:wrap;align-items:center;opacity:0;animation:hUp .9s .65s ease forwards}
        .h-btn-p{font-family:'Tenor Sans',sans-serif;font-size:.68rem;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:#030024;background:#F0C277;padding:15px 34px;border:none;border-radius:3px;cursor:pointer;transition:background .3s,transform .25s,box-shadow .3s}
        .h-btn-p:hover{transform:translateY(-2px);box-shadow:0 16px 40px rgba(200,132,30,.35);background:#d9a85a}
        .h-btn-g{font-family:'Tenor Sans',sans-serif;font-size:.68rem;font-weight:400;letter-spacing:.2em;text-transform:uppercase;color:rgba(248,245,239,.8);background:transparent;border:1px solid rgba(248,245,239,.22);padding:15px 34px;border-radius:3px;cursor:pointer;transition:border-color .3s,color .3s,background .3s}
        .h-btn-g:hover{border-color:rgba(102,172,161,.6);color:#fff;background:rgba(102,172,161,.08)}
        .h-scroll-cta{display:flex;align-items:center;gap:.7rem;margin-top:2rem;cursor:pointer;background:none;border:none;padding:0}
        .h-scroll-line{width:28px;height:1px;background:rgba(248,245,239,.22);transition:width .3s}
        .h-scroll-cta:hover .h-scroll-line{width:48px}
        .h-scroll-txt{font-family:'Tenor Sans',sans-serif;font-size:.6rem;letter-spacing:.32em;text-transform:uppercase;color:rgba(248,245,239,.32);transition:color .3s}
        .h-scroll-cta:hover .h-scroll-txt{color:rgba(248,245,239,.6)}

        .h-right{opacity:0;animation:hFade 1.2s .8s ease forwards}
        .h-card{background:rgba(255,255,255,.03);border:1px solid rgba(102,172,161,.14);backdrop-filter:blur(20px);border-radius:6px;padding:2.4rem;position:relative;overflow:hidden}
        .h-card::before{content:'';position:absolute;top:0;left:0;right:0;height:1px;background:linear-gradient(90deg,transparent,rgba(240,194,119,.5),transparent)}
        .h-card-tag{font-family:'Tenor Sans',sans-serif;font-size:.56rem;letter-spacing:.3em;text-transform:uppercase;color:#F0C277;margin-bottom:1.6rem;display:flex;align-items:center;gap:.7rem}
        .h-card-tag::before{content:'';width:20px;height:1px;background:#F0C277}
        .h-card-title{font-family:'Cormorant Garamond',Georgia,serif;font-size:1.25rem;font-weight:400;color:#F8F5EF;line-height:1.35;margin-bottom:.4rem}
        .h-card-loc{font-family:'Tenor Sans',sans-serif;font-size:.62rem;letter-spacing:.12em;text-transform:uppercase;color:rgba(248,245,239,.38);display:flex;align-items:center;gap:.5rem;margin-bottom:1.6rem}
        .h-card-loc::before{content:'◎';color:#66ACA1;font-size:.65rem}
        .h-card-div{height:1px;background:rgba(102,172,161,.12);margin-bottom:1.4rem}
        .h-card-price{font-family:'Cormorant Garamond',Georgia,serif;font-size:1.85rem;font-weight:600;color:#66ACA1;line-height:1;margin-bottom:.3rem}
        .h-card-plabel{font-family:'Tenor Sans',sans-serif;font-size:.56rem;letter-spacing:.2em;text-transform:uppercase;color:rgba(248,245,239,.28);margin-bottom:1.4rem;display:block}
        .h-card-specs{display:grid;grid-template-columns:repeat(3,1fr);gap:1px;background:rgba(102,172,161,.1);margin-bottom:1.6rem}
        .h-spec{background:rgba(255,255,255,.02);padding:.8rem .6rem;text-align:center}
        .h-spec-v{font-family:'Cormorant Garamond',Georgia,serif;font-size:1.1rem;font-weight:400;color:#F8F5EF;line-height:1}
        .h-spec-k{font-family:'Tenor Sans',sans-serif;font-size:.52rem;letter-spacing:.18em;text-transform:uppercase;color:rgba(248,245,239,.32);margin-top:4px;display:block}
        .h-card-cta{width:100%;padding:12px;font-family:'Tenor Sans',sans-serif;font-size:.62rem;font-weight:500;letter-spacing:.2em;text-transform:uppercase;color:rgba(248,245,239,.65);background:rgba(102,172,161,.08);border:1px solid rgba(102,172,161,.22);border-radius:3px;cursor:pointer;transition:background .3s,color .3s,border-color .3s}
        .h-card-cta:hover{background:rgba(102,172,161,.18);color:#fff;border-color:rgba(102,172,161,.5)}

        .h-stats{position:relative;z-index:2;display:grid;grid-template-columns:repeat(4,1fr);border-top:1px solid rgba(102,172,161,.1);opacity:0;animation:hFade 1s 1.1s ease forwards}
        .h-stat{padding:2.2rem 2.5rem;border-right:1px solid rgba(102,172,161,.08);transition:background .3s;cursor:default}
        .h-stat:last-child{border-right:none}
        .h-stat:hover{background:rgba(102,172,161,.04)}
        .h-stat-n{font-family:'Cormorant Garamond',Georgia,serif;font-size:2.4rem;font-weight:500;color:#F0C277;line-height:1;letter-spacing:-.02em}
        .h-stat-l{font-family:'Tenor Sans',sans-serif;font-size:.58rem;letter-spacing:.22em;text-transform:uppercase;color:rgba(248,245,239,.32);margin-top:6px}

        .h-badge{position:absolute;top:5.5rem;right:4.5rem;z-index:3;width:86px;height:86px;border:1px solid rgba(240,194,119,.18);border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;background:rgba(240,194,119,.03);backdrop-filter:blur(8px);opacity:0;animation:hBadge 20s 1.2s linear forwards}
        @keyframes hBadge{0%{opacity:0;transform:rotate(0)} 10%{opacity:1} 100%{opacity:1;transform:rotate(360deg)}}
        .h-badge-inner{display:flex;flex-direction:column;align-items:center;animation:hBadgeR 20s 1.2s linear infinite}
        @keyframes hBadgeR{from{transform:rotate(0)} to{transform:rotate(-360deg)}}
        .h-badge-n{font-family:'Cormorant Garamond',Georgia,serif;font-size:1.5rem;font-weight:600;color:#F0C277;line-height:1}
        .h-badge-t{font-family:'Tenor Sans',sans-serif;font-size:.44rem;letter-spacing:.2em;text-transform:uppercase;color:rgba(240,194,119,.5);margin-top:2px;text-align:center}
        .h-scroll-ind{position:absolute;right:2.5rem;top:50%;transform:translateY(-50%);z-index:3;display:flex;flex-direction:column;align-items:center;gap:.8rem;opacity:0;animation:hFade 1.2s 1.5s ease forwards}
        .h-scroll-lbl{font-family:'Tenor Sans',sans-serif;font-size:.48rem;letter-spacing:.35em;text-transform:uppercase;color:rgba(248,245,239,.2);writing-mode:vertical-rl}
        .h-scroll-trk{width:1px;height:64px;background:rgba(248,245,239,.1);position:relative;overflow:hidden}
        .h-scroll-thb{position:absolute;top:-100%;width:100%;height:100%;background:linear-gradient(180deg,transparent,#66ACA1);animation:hScrollT 2.2s ease-in-out infinite}
        @keyframes hScrollT{0%{top:-100%;opacity:0} 20%{opacity:1} 80%{opacity:1} 100%{top:100%;opacity:0}}
        @keyframes hUp{from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)}}
        @keyframes hFade{to{opacity:1}}
        
       

        /* ══════════════════════════════════
   ABOUT TEASER — THEME SUPPORT
══════════════════════════════════ */

.ht-about{
  background:var(--bg);
  padding:8rem 0;
  position:relative;
  transition:background var(--transition)
}

.ht-about::before{
  content:'';
  display:block;
  height:1px;
  background:linear-gradient(
    90deg,
    transparent,
    var(--border-t),
    transparent
  )
}

.ht-wrap{
  max-width:1300px;
  margin:0 auto;
  padding:0 3rem
}

.ht-about-grid{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:6rem;
  align-items:start;
  padding-top:5rem
}

/* section label */
.ht-sec-tag{
  font-family:var(--ff-ui);
  font-size:.72rem;
  font-weight:600;
  letter-spacing:.42em;
  text-transform:uppercase;
  display:inline-flex;
  align-items:center;
  gap:1rem;
  color:var(--teal)
}

.ht-sec-tag::before{
  content:'';
  display:block;
  width:34px;
  height:1px;
  background:currentColor;
  flex-shrink:0
}

/* heading */
.ht-h2{
  font-family:var(--ff-h);
  font-size:clamp(2.6rem,4vw,4rem);
  font-weight:400;
  line-height:1.08;
  color:var(--ink);
  margin:1.2rem 0 2.2rem
}

.ht-h2 em{
  color:var(--teal);
  font-style:italic;
  font-weight:500
}

/* paragraph */
.ht-p{
  font-family:var(--ff-b);
  font-size:1rem;
  font-weight:400;
  line-height:2;
  letter-spacing:.01em;
  color:var(--ink2);
  margin-bottom:1.5rem
}

/* divider */
.ht-divider{
  width:60px;
  height:1px;
  background:rgba(102,172,161,.32);
  margin:2.5rem 0
}

/* mission box */
.ht-mission{
  border-left:3px solid var(--teal);
  padding:1.6rem 1.8rem;
  background:var(--teal-pale);
  margin-bottom:1.2rem;
  border-radius:0 6px 6px 0;
  transition:background var(--transition)
}

.ht-mission-lbl{
  font-family:var(--ff-ui);
  font-size:.68rem;
  font-weight:600;
  letter-spacing:.3em;
  text-transform:uppercase;
  color:var(--teal);
  margin-bottom:.7rem
}

.ht-mission-txt{
  font-family:var(--ff-h);
  font-size:1.2rem;
  font-style:italic;
  font-weight:400;
  color:var(--ink2);
  line-height:1.8
}

/* values grid */
.ht-vals-grid{
  margin-top:1rem;
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:1px;
  background:var(--border)
}

.ht-val{
  background:var(--surface);
  padding:2rem;
  position:relative;
  transition:background .28s,transform .28s;
  cursor:default;
  overflow:hidden
}

.ht-val:hover{
  background:var(--surface2);
  transform:translateY(-2px)
}

.ht-val-n{
  position:absolute;
  top:1rem;
  right:1.2rem;
  font-family:var(--ff-h);
  font-size:3rem;
  font-weight:300;
  color:rgba(120,120,120,.08);
  line-height:1;
  pointer-events:none
}

.ht-val-bar{
  width:28px;
  height:2px;
  background:var(--gold);
  margin-bottom:1rem;
  border-radius:1px
}

.ht-val-title{
  font-family:var(--ff-ui);
  font-size:.76rem;
  font-weight:600;
  letter-spacing:.16em;
  text-transform:uppercase;
  color:var(--ink);
  margin-bottom:.7rem;
  transition:color .28s
}

.ht-val:hover .ht-val-title{
  color:var(--teal)
}

.ht-val-desc{
  font-family:var(--ff-b);
  font-size:.9rem;
  font-weight:400;
  line-height:1.9;
  color:var(--ink3)
}

/* button */
.ht-see-more{
  display:inline-flex;
  align-items:center;
  gap:.8rem;
  margin-top:2.7rem;
  font-family:var(--ff-ui);
  font-size:.72rem;
  font-weight:600;
  letter-spacing:.22em;
  text-transform:uppercase;
  color:var(--teal);
  background:none;
  border:1px solid var(--border-t);
  padding:14px 30px;
  border-radius:4px;
  cursor:pointer;
  transition:all .28s ease
}

.ht-see-more:hover{
  border-color:var(--teal);
  background:rgba(102,172,161,.08);
  color:var(--ink);
  transform:translateY(-2px)
}

/* responsive */
@media(max-width:1050px){
  .ht-about-grid{
    grid-template-columns:1fr;
    gap:4rem
  }
}

@media(max-width:700px){

  .ht-wrap{
    padding:0 1.4rem
  }

  .ht-about{
    padding:5rem 0
  }

  .ht-h2{
    font-size:2.5rem
  }

  .ht-vals-grid{
    grid-template-columns:1fr
  }

  .ht-p{
    font-size:.96rem
  }

  .ht-val-desc{
    font-size:.86rem
  }
}
        /* ══════════════════════════════════
           SERVICES PREVIEW — dark
        ══════════════════════════════════ */
        .ht-services{background:#030024;padding:8rem 0;position:relative}
        .ht-services::before{content:'';display:block;height:1px;background:linear-gradient(90deg,transparent,rgba(102,172,161,.25),transparent)}
        .ht-svc-head{display:flex;align-items:flex-end;justify-content:space-between;padding-top:4.5rem;margin-bottom:3.5rem;gap:2rem;flex-wrap:wrap}
        .ht-svc-tag{font-family:'Tenor Sans',sans-serif;font-size:.58rem;letter-spacing:.42em;text-transform:uppercase;display:inline-flex;align-items:center;gap:1rem;color:#F0C277}
        .ht-svc-tag::before{content:'';display:block;width:32px;height:1px;background:currentColor;flex-shrink:0}
        .ht-svc-h2{font-family:'Cormorant Garamond',Georgia,serif;font-size:clamp(2rem,3.8vw,3.3rem);font-weight:300;line-height:1.1;color:#F8F5EF;margin-top:.8rem}
        .ht-svc-h2 em{color:#66ACA1;font-style:italic;font-weight:400}
        .ht-svc-sub{font-family:'Montserrat',sans-serif;font-size:.78rem;font-weight:300;line-height:1.9;color:rgba(248,245,239,.5);max-width:320px;align-self:flex-end}
        .ht-svc-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1px;background:rgba(102,172,161,.08)}
        .ht-svc-card{background:rgba(255,255,255,.025);padding:2.6rem 2.2rem;position:relative;overflow:hidden;cursor:default;transition:background .3s}
        .ht-svc-card:hover{background:rgba(102,172,161,.06)}
        .ht-svc-line{position:absolute;top:0;left:0;right:0;height:2px;background:#66ACA1;transform:scaleX(0);transform-origin:left;transition:transform .4s ease}
        .ht-svc-card:hover .ht-svc-line{transform:scaleX(1)}
        .ht-svc-n{font-family:'Cormorant Garamond',Georgia,serif;font-size:2.8rem;font-weight:300;line-height:1;color:rgba(102,172,161,.15);margin-bottom:1.4rem;transition:color .3s}
        .ht-svc-card:hover .ht-svc-n{color:rgba(102,172,161,.32)}
        .ht-svc-title{font-family:'Tenor Sans',sans-serif;font-size:.7rem;letter-spacing:.16em;text-transform:uppercase;color:#F8F5EF;margin-bottom:.9rem;transition:color .3s}
        .ht-svc-card:hover .ht-svc-title{color:#66ACA1}
        .ht-svc-desc{font-family:'Montserrat',sans-serif;font-size:.77rem;font-weight:300;line-height:1.9;color:rgba(248,245,239,.5);margin-bottom:1.4rem}
        .ht-svc-tags{display:flex;flex-wrap:wrap;gap:6px}
        .ht-svc-pill{font-family:'Montserrat',sans-serif;font-size:.65rem;color:#66ACA1;border:1px solid rgba(102,172,161,.22);padding:3px 10px;border-radius:20px;transition:border-color .3s,background .3s}
        .ht-svc-card:hover .ht-svc-pill{border-color:rgba(102,172,161,.45);background:rgba(102,172,161,.06)}
        .ht-svc-arr{position:absolute;top:1.4rem;right:1.4rem;font-size:1rem;color:rgba(102,172,161,.2);transition:color .3s,transform .3s}
        .ht-svc-card:hover .ht-svc-arr{color:#F0C277;transform:translate(3px,-3px)}
        .ht-svc-cta-row{margin-top:2.5rem;display:flex;justify-content:center}
        .ht-dark-btn{font-family:'Tenor Sans',sans-serif;font-size:.65rem;letter-spacing:.2em;text-transform:uppercase;color:#66ACA1;border:1px solid rgba(102,172,161,.3);padding:13px 30px;border-radius:3px;cursor:pointer;background:transparent;transition:border-color .3s,color .3s,background .3s}
        .ht-dark-btn:hover{border-color:#66ACA1;color:#F8F5EF;background:rgba(102,172,161,.08)}

      /* ══════════════════════════════════
   PARTNERS STRIP — LIGHT + DARK
══════════════════════════════════ */

/* LIGHT THEME */
.ht-partners{
    --prt-bg:#FFFFFF;
    --prt-surface:#FFFFFF;
    --prt-surface-hover:#F7F9F8;
    --prt-border:rgba(3,0,36,.06);
    --prt-border-soft:rgba(3,0,36,.08);
    --prt-text:#030024;
    --prt-text-soft:rgba(3,0,36,.45);
    --prt-marquee:rgba(3,0,36,.25);
    --prt-accent:#66ACA1;

    background:var(--prt-bg);
    padding:5rem 0;
    position:relative;
    transition:
        background .35s ease,
        color .35s ease;
}

.ht-partners::before{
    content:'';
    display:block;
    height:1px;
    background:linear-gradient(
        90deg,
        transparent,
        var(--prt-border-soft),
        transparent
    );
}

/* AUTO DARK MODE */
.dark .ht-partners,
[data-theme='dark'] .ht-partners{
    --prt-bg:#070B14;
    --prt-surface:#0D1422;
    --prt-surface-hover:#121B2B;
    --prt-border:rgba(255,255,255,.06);
    --prt-border-soft:rgba(255,255,255,.08);
    --prt-text:#F5F7FA;
    --prt-text-soft:rgba(255,255,255,.62);
    --prt-marquee:rgba(255,255,255,.22);
    --prt-accent:#7ED0C3;
}

/* ══ Header ══ */
.ht-prt-head{
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding-top:3.5rem;
    margin-bottom:2.8rem;
    gap:2rem;
    flex-wrap:wrap;
}

.ht-prt-tag{
    font-family:'Tenor Sans',sans-serif;
    font-size:.68rem;
    letter-spacing:.34em;
    text-transform:uppercase;
    display:inline-flex;
    align-items:center;
    gap:1rem;
    color:var(--prt-accent);
}

.ht-prt-tag::before{
    content:'';
    display:block;
    width:34px;
    height:1px;
    background:currentColor;
    flex-shrink:0;
}

.ht-prt-h2{
    font-family:'Cormorant Garamond',Georgia,serif;
    font-size:clamp(2rem,3.4vw,3rem);
    font-weight:300;
    line-height:1.08;
    color:var(--prt-text);
    margin-top:.8rem;
    transition:color .35s ease;
}

.ht-prt-h2 em{
    color:var(--prt-accent);
    font-style:italic;
    font-weight:400;
}

/* ══ Grid ══ */
.ht-prt-grid{
    display:grid;
    grid-template-columns:repeat(4,1fr);
    gap:1px;
    background:var(--prt-border);
    border:1px solid var(--prt-border);
}

/* ══ Card ══ */
.ht-prt-card{
    background:var(--prt-surface);
    padding:2.4rem 1.6rem;
    display:flex;
    flex-direction:column;
    align-items:center;
    gap:1rem;
    cursor:default;
    position:relative;
    overflow:hidden;
    transition:
        background .3s ease,
        transform .3s ease,
        border-color .3s ease;
}

.ht-prt-card::after{
    content:'';
    position:absolute;
    left:0;
    right:0;
    bottom:0;
    height:2px;
    background:linear-gradient(
        90deg,
        transparent,
        var(--prt-accent),
        transparent
    );
    transform:scaleX(0);
    transition:transform .45s ease;
}

.ht-prt-card:hover{
    background:var(--prt-surface-hover);
    transform:translateY(-4px);
}

.ht-prt-card:hover::after{
    transform:scaleX(1);
}

/* ══ Icon ══ */
.ht-prt-icon{
    width:58px;
    height:58px;
    border:1px solid var(--prt-border-soft);
    border-radius:50%;
    display:flex;
    align-items:center;
    justify-content:center;

    font-family:'Cormorant Garamond',Georgia,serif;
    font-size:1.4rem;
    font-style:italic;
    font-weight:600;

    color:var(--prt-text);
    transition:
        border-color .3s ease,
        color .3s ease,
        background .3s ease;
}

.ht-prt-card:hover .ht-prt-icon{
    border-color:var(--prt-accent);
    color:var(--prt-accent);
    background:rgba(102,172,161,.08);
}

/* ══ Name ══ */
.ht-prt-name{
    font-family:'Tenor Sans',sans-serif;
    font-size:.72rem;
    letter-spacing:.16em;
    text-transform:uppercase;
    color:var(--prt-text-soft);
    text-align:center;
    line-height:1.7;
    transition:color .3s ease;
}

.ht-prt-card:hover .ht-prt-name{
    color:var(--prt-text);
}

/* ══ Description ══ */
.ht-prt-note{
    font-family:'Montserrat',sans-serif;
    font-size:.9rem;
    font-weight:400;
    line-height:1.8;
    color:var(--prt-text-soft);
    text-align:center;
    max-width:220px;
}

/* ══ Marquee ══ */
.ht-marquee{
    margin-top:2.8rem;
    overflow:hidden;
    border-top:1px solid var(--prt-border);
    padding-top:1.8rem;
}

.ht-track{
    display:flex;
    gap:4rem;
    white-space:nowrap;
    animation:marquee 28s linear infinite;
}

.ht-track:hover{
    animation-play-state:paused;
}

.ht-track-item{
    font-family:'Tenor Sans',sans-serif;
    font-size:.66rem;
    letter-spacing:.24em;
    text-transform:uppercase;
    color:var(--prt-marquee);
}

/* ══ Button ══ */
.ht-see-more{
    display:inline-flex;
    align-items:center;
    gap:.7rem;

    font-family:'Tenor Sans',sans-serif;
    font-size:.68rem;
    letter-spacing:.2em;
    text-transform:uppercase;

    color:var(--prt-accent);
    background:transparent;

    border:1px solid rgba(102,172,161,.35);
    padding:13px 28px;
    border-radius:4px;

    cursor:pointer;

    transition:
        border-color .3s ease,
        background .3s ease,
        color .3s ease,
        transform .3s ease;
}

.ht-see-more:hover{
    border-color:var(--prt-accent);
    background:rgba(102,172,161,.08);
    color:var(--prt-text);
    transform:translateY(-2px);
}

/* ══ Animation ══ */
@keyframes marquee{
    from{transform:translateX(0)}
    to{transform:translateX(-50%)}
}

/* ══════════════════════════════════
   RESPONSIVE
══════════════════════════════════ */

@media (max-width:1000px){

    .ht-prt-grid{
        grid-template-columns:repeat(2,1fr);
    }

    .ht-prt-h2{
        font-size:2.2rem;
    }
}

@media (max-width:640px){

    .ht-prt-head{
        align-items:flex-start;
    }

    .ht-prt-grid{
        grid-template-columns:1fr;
    }

    .ht-prt-card{
        padding:2rem 1.4rem;
    }

    .ht-prt-h2{
        font-size:1.9rem;
    }

    .ht-prt-name{
        font-size:.66rem;
    }

    .ht-prt-note{
        font-size:.84rem;
    }

    .ht-track{
        gap:2.5rem;
    }
}

        /* ══════════════════════════════════
           PROPERTIES PREVIEW — dark
        ══════════════════════════════════ */
        .ht-props{background:#030024;padding:8rem 0}
        .ht-props::before{content:'';display:block;height:1px;background:linear-gradient(90deg,transparent,rgba(102,172,161,.2),transparent)}
        .ht-prop-head{display:flex;align-items:flex-end;justify-content:space-between;padding-top:5rem;margin-bottom:3rem;gap:1.5rem;flex-wrap:wrap}
        .ht-prop-tag{font-family:'Tenor Sans',sans-serif;font-size:.58rem;letter-spacing:.42em;text-transform:uppercase;display:inline-flex;align-items:center;gap:1rem;color:#F0C277}
        .ht-prop-tag::before{content:'';display:block;width:32px;height:1px;background:currentColor;flex-shrink:0}
        .ht-prop-h2{font-family:'Cormorant Garamond',Georgia,serif;font-size:clamp(2rem,3.8vw,3.3rem);font-weight:300;color:#F8F5EF;margin-top:.8rem;line-height:1.1}
        .ht-prop-h2 em{color:#66ACA1;font-style:italic;font-weight:400}
        .ht-prop-tabs{display:flex;border:1px solid rgba(102,172,161,.2);border-radius:4px;overflow:hidden}
        .ht-prop-tab{font-family:'Tenor Sans',sans-serif;font-size:.62rem;letter-spacing:.16em;text-transform:uppercase;padding:11px 26px;cursor:pointer;background:transparent;color:rgba(248,245,239,.5);transition:background .28s,color .28s;border:none}
        .ht-prop-tab.on{background:#66ACA1;color:#FFFFFF}
        .ht-prop-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:1px;background:rgba(102,172,161,.08)}
        .ht-pc{background:rgba(255,255,255,.025);padding:2.2rem;position:relative;cursor:default;transition:background .3s;overflow:hidden}
        .ht-pc:hover{background:rgba(102,172,161,.07)}
        .ht-pc-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:.9rem}
        .ht-pc-badge{font-family:'Tenor Sans',sans-serif;font-size:.55rem;letter-spacing:.18em;text-transform:uppercase;background:#F0C277;color:#030024;padding:3px 10px;border-radius:2px}
        .ht-pc-arr{font-size:.95rem;color:rgba(102,172,161,.22);transition:color .3s,transform .3s}
        .ht-pc:hover .ht-pc-arr{color:#F0C277;transform:translate(3px,-3px)}
        .ht-pc-loc{font-family:'Tenor Sans',sans-serif;font-size:.58rem;letter-spacing:.12em;text-transform:uppercase;color:rgba(248,245,239,.3);margin-bottom:.6rem}
        .ht-pc-title{font-family:'Cormorant Garamond',Georgia,serif;font-size:1.2rem;font-weight:400;color:#F8F5EF;line-height:1.25;margin-bottom:1.1rem;transition:color .3s}
        .ht-pc:hover .ht-pc-title{color:#85C4BA}
        .ht-pc-div{height:1px;background:rgba(102,172,161,.1);margin-bottom:1.1rem}
        .ht-pc-price{font-family:'Cormorant Garamond',Georgia,serif;font-size:1.3rem;font-weight:400;color:#85C4BA;margin-bottom:.9rem}
        .ht-pc-meta{display:flex;gap:1.6rem}
        .ht-pc-meta-item{display:flex;flex-direction:column;gap:2px}
        .ht-pc-meta-v{font-family:'Cormorant Garamond',Georgia,serif;font-size:1rem;font-weight:400;color:#F8F5EF;line-height:1}
        .ht-pc-meta-l{font-family:'Tenor Sans',sans-serif;font-size:.5rem;letter-spacing:.2em;text-transform:uppercase;color:rgba(248,245,239,.3)}

        /* ══════════════════════════════════
           CTA BANNER — gold
        ══════════════════════════════════ */
        .ht-cta{background:linear-gradient(135deg,#F0C277 0%,#d9a85a 100%);padding:5rem 0}
        .ht-cta-inner{max-width:1300px;margin:0 auto;padding:0 2.5rem;display:flex;align-items:center;justify-content:space-between;gap:3rem;flex-wrap:wrap}
        .ht-cta-h{font-family:'Cormorant Garamond',Georgia,serif;font-size:clamp(1.8rem,3.5vw,3rem);font-weight:300;color:#030024;line-height:1.2}
        .ht-cta-h em{font-style:italic;font-weight:500}
        .ht-cta-p{font-family:'Montserrat',sans-serif;font-size:.8rem;font-weight:300;color:rgba(3,0,36,.65);margin-top:.8rem;max-width:400px;line-height:1.8}
        .ht-cta-btn{font-family:'Tenor Sans',sans-serif;font-size:.68rem;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:#F8F5EF;background:#030024;padding:16px 36px;border:none;border-radius:3px;cursor:pointer;transition:background .28s,transform .2s,box-shadow .3s;white-space:nowrap}
        .ht-cta-btn:hover{background:#0a0040;transform:translateY(-2px);box-shadow:0 12px 32px rgba(3,0,36,.25)}

        /* ══════════════════════════════════
           RESPONSIVE
        ══════════════════════════════════ */
        @media(max-width:1150px){
          .hero-body{grid-template-columns:1fr;padding:8rem 3rem 4rem;gap:3rem}
          .h-right,.h-scroll-ind,.h-badge{display:none}
          .h-stats{grid-template-columns:repeat(4,1fr)}
        }
        @media(max-width:1050px){
          .ht-about-grid{grid-template-columns:1fr;gap:4rem}
          .ht-svc-grid{grid-template-columns:1fr 1fr}
          .ht-prt-grid{grid-template-columns:repeat(2,1fr)}
          .ht-prop-grid{grid-template-columns:1fr}
        }
        @media(max-width:700px){
          .hero-body{padding:7.5rem 1.5rem 3rem}
          .h-h1{font-size:clamp(2.6rem,11vw,4rem)}
          .h-stats{grid-template-columns:repeat(2,1fr)}
          .h-stat:nth-child(2){border-right:none}
          .h-stat{padding:1.6rem 1.5rem}
          .h-btns{flex-direction:column}
          .h-btn-p,.h-btn-g{width:100%;text-align:center}
          .ht-wrap{padding:0 1.2rem}
          .ht-about-grid,.ht-svc-grid,.ht-prop-grid{grid-template-columns:1fr}
          .ht-svc-head,.ht-prop-head,.ht-prt-head{flex-direction:column;align-items:flex-start}
          .ht-about,.ht-services,.ht-props,.ht-partners{padding:5rem 0}
          .ht-vals-grid{grid-template-columns:1fr}
          .ht-cta-inner{flex-direction:column;text-align:center}
          .ht-cta-p{max-width:100%}
        }
        @media(max-width:480px){
          .hero-body{padding:7rem 1.2rem 2.5rem}
          .h-h1{font-size:2.4rem}
          .h-sub{font-size:.95rem}
          .ht-prt-grid{grid-template-columns:1fr 1fr}
        }
      `}</style>

            {/* ══ HERO BANNER ══ */}
            <section id="home" className="hero" ref={heroRef}>
                <div className="hero-canvas">
                    <div className="hero-base" />
                    <div className="hero-orb1" style={{ transform:`translate(${mousePos.x*.08-50}px,${mousePos.y*.08-20}px)` }} />
                    <div className="hero-orb2" style={{ transform:`translate(${mousePos.x*-.05+20}px,${mousePos.y*-.04+10}px)` }} />
                    <div className="hero-grid" />
                    <div className="hero-diag" />
                    <div className="hero-diag2" />
                </div>
                <div className="h-badge">
                    <div className="h-badge-inner">
                        <span className="h-badge-n">Since</span>
                        <span className="h-badge-t">2019<br/>UAE</span>
                    </div>
                </div>
                <div className="hero-body">
                    <div>
                        <div className="h-eyebrow">
                            <span className="h-ey-line"/><span className="h-ey-t1">UAE Premier</span>
                            <span className="h-ey-dot"/><span className="h-ey-t2">Real Estate</span>
                        </div>
                        <div className="h-heading">
                            <h1 className="h-h1">
                                Where Property<br/>
                                <span className="h-h1-row2">
                  <span className="h-static">Becomes</span>
                  <span className="h-rotating" style={{opacity:fade?1:0,transform:fade?'translateY(0)':'translateY(12px)'}}>
                    {ROTATING[wordIdx]}
                  </span>
                </span>
                            </h1>
                        </div>
                        <p className="h-tagline">"Where Property Becomes Prosperity."</p>
                        <p className="h-sub">
                            A trusted and value-driven real estate partner in the UAE — recognised for professional
                            standards, transparent dealings, and long-term client relationships.
                        </p>
                        <div className="h-btns">
                            <button className="h-btn-p" onClick={()=>go('/sale')}>Explore Properties</button>
                            <button className="h-btn-g" onClick={()=>go('/contact')}>Request Consultation</button>
                        </div>
                        <button className="h-scroll-cta" onClick={()=>go('/about')}>
                            <span className="h-scroll-line"/><span className="h-scroll-txt">Discover More</span>
                        </button>
                    </div>
                    <div className="h-right">
                        <div className="h-card">
                            <p className="h-card-tag">Featured Listing</p>
                            <h3 className="h-card-title">Signature Penthouse<br/>Emirates Hills</h3>
                            <p className="h-card-loc">Dubai, UAE</p>
                            <div className="h-card-div"/>
                            <p className="h-card-price">AED 22,000,000</p>
                            <span className="h-card-plabel">Sale Price</span>
                            <div className="h-card-specs">
                                {[{v:'6',k:'Beds'},{v:'7',k:'Baths'},{v:'9.5k',k:'Sq.Ft'}].map(s=>(
                                    <div key={s.k} className="h-spec">
                                        <span className="h-spec-v">{s.v}</span>
                                        <span className="h-spec-k">{s.k}</span>
                                    </div>
                                ))}
                            </div>
                            <button className="h-card-cta" onClick={()=>go('/contact')}>Request Viewing ↗</button>
                        </div>
                    </div>
                </div>
                <div className="h-stats">
                    {STATS.map(s=>(
                        <div key={s.label} className="h-stat">
                            <div className="h-stat-n">{s.num}</div>
                            <div className="h-stat-l">{s.label}</div>
                        </div>
                    ))}
                </div>
                <div className="h-scroll-ind">
                    <span className="h-scroll-lbl">Scroll</span>
                    <div className="h-scroll-trk"><div className="h-scroll-thb"/></div>
                </div>
            </section>



            {/* ══ ABOUT TEASER ══ */}
            <section className="ht-about">
                <div className="ht-wrap">
                    <div className="ht-about-grid">

                        {/* LEFT */}
                        <div>
                            <p className="ht-sec-tag">About Us</p>

                            <h2 className="ht-h2">
                                Redefining UAE Real Estate Through <em>Trust & Excellence</em>
                            </h2>

                            <p className="ht-p">
                                Burj Al Arab Real Estate delivers refined property solutions tailored for
                                investors, homeowners, landlords, and corporate clients across the UAE.
                            </p>

                            <p className="ht-p">
                                From premium residences to strategic investments, our approach combines
                                market expertise, transparent guidance, and long-term value creation.
                            </p>

                            <div className="ht-divider"/>

                            <div className="ht-mission">
                                <p className="ht-mission-lbl">What Sets Us Apart</p>

                                <p className="ht-mission-txt">
                                    Professional standards, transparent transactions, and relationships
                                    built on confidence and consistency.
                                </p>
                            </div>

                            <button
                                className="ht-see-more"
                                onClick={() => go('/about')}
                            >
                                Discover Our Story ↗
                            </button>
                        </div>

                        {/* RIGHT */}
                        <div>
                            <p className="ht-sec-tag" style={{ color:'#66ACA1' }}>
                                Why Clients Choose Us
                            </p>

                            <div className="ht-vals-grid">

                                {[
                                    {
                                        n:'01',
                                        title:'Market Expertise',
                                        desc:'Deep understanding of the UAE property landscape and investment trends.'
                                    },
                                    {
                                        n:'02',
                                        title:'Trusted Guidance',
                                        desc:'Clear communication and honest advice throughout every transaction.'
                                    },
                                    {
                                        n:'03',
                                        title:'Premium Service',
                                        desc:'Personalized support designed around client goals and expectations.'
                                    },
                                    {
                                        n:'04',
                                        title:'Long-Term Value',
                                        desc:'Strategies focused on sustainable growth and property performance.'
                                    }
                                ].map(v => (
                                    <div key={v.n} className="ht-val">
                                        <div className="ht-val-n">{v.n}</div>

                                        <div className="ht-val-bar"/>

                                        <p className="ht-val-title">{v.title}</p>

                                        <p className="ht-val-desc">{v.desc}</p>
                                    </div>
                                ))}

                            </div>

                            <button
                                className="ht-see-more"
                                style={{ marginTop:'1.5rem' }}
                                onClick={() => go('/about')}
                            >
                                Learn More About Our Vision ↗
                            </button>
                        </div>

                    </div>
                </div>
            </section>

            {/*<section className="ht-values">*/}
            {/*    <div className="ht-wrap">*/}

            {/*        <p className="ht-sec-tag">Our Core Values</p>*/}
            {/*        <h2 className="ht-h2">*/}
            {/*            What Drives <em>Us</em>*/}
            {/*        </h2>*/}

            {/*        <div className="ht-values-grid">*/}
            {/*            {VALUES_PREVIEW.map((v, i) => (*/}
            {/*                <div className="ht-value-card" key={i}>*/}
            {/*                    <div className="ht-value-icon">{v.icon}</div>*/}
            {/*                    <h3 className="ht-value-title">{v.title}</h3>*/}
            {/*                    <p className="ht-value-desc">{v.desc}</p>*/}
            {/*                </div>*/}
            {/*            ))}*/}
            {/*        </div>*/}

            {/*    </div>*/}
            {/*</section>*/}

            {/* ══ SERVICES PREVIEW ══ */}
            <section className="ht-services">
                <div className="ht-wrap">
                    <div className="ht-svc-head">
                        <div>
                            <p className="ht-svc-tag">What We Offer</p>
                            <h2 className="ht-svc-h2">Comprehensive Real Estate <em>Services</em></h2>
                        </div>
                        <p className="ht-svc-sub">Professional solutions crafted for every property need across the UAE market.</p>
                    </div>
                    <div className="ht-svc-grid">
                        {SERVICES_PREVIEW.map(s=>(
                            <div key={s.n} className="ht-svc-card">
                                <div className="ht-svc-line"/>
                                <div className="ht-svc-n">{s.n}</div>
                                <p className="ht-svc-title">{s.title}</p>
                                <p className="ht-svc-desc">{s.desc}</p>
                                <div className="ht-svc-tags">
                                    {s.tags.map(t=><span key={t} className="ht-svc-pill">{t}</span>)}
                                </div>
                                <span className="ht-svc-arr">↗</span>
                            </div>
                        ))}
                    </div>
                    <div className="ht-svc-cta-row">
                        <button className="ht-dark-btn" onClick={()=>go('/services')}>View All Services ↗</button>
                    </div>
                </div>
            </section>

            {/* ══ PARTNERS STRIP ══ */}
            <section className="ht-partners">
                <div className="ht-wrap">
                    <div className="ht-prt-head">
                        <div>
                            <p className="ht-prt-tag">Trusted By</p>
                            <h2 className="ht-prt-h2">Our Developer <em>Partners</em></h2>
                        </div>
                        <button className="ht-see-more" onClick={()=>go('/partners')}>View All Partners ↗</button>
                    </div>
                    <div className="ht-prt-grid">
                        {PARTNERS.map(p=>(
                            <div key={p} className="ht-prt-card">
                                <div className="ht-prt-icon">{p.charAt(0)}</div>
                                <p className="ht-prt-name">{p}</p>
                            </div>
                        ))}
                    </div>
                    <div className="ht-marquee">
                        <div className="ht-track">
                            {[...PARTNERS,...PARTNERS].map((p,i)=>(
                                <span key={i} className="ht-track-item">{p} &nbsp;·&nbsp; </span>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* ══ PROPERTIES PREVIEW ══ */}
            <section className="ht-props">
                <div className="ht-wrap">
                    <div className="ht-prop-head">
                        <div>
                            <p className="ht-prop-tag">Portfolio</p>
                            <h2 className="ht-prop-h2">
                                {propTab==='sale'?<>Featured Properties for <em>Sale</em></>:<>Featured Properties for <em>Rent</em></>}
                            </h2>
                        </div>
                        <div className="ht-prop-tabs">
                            <button className={`ht-prop-tab${propTab==='sale'?' on':''}`} onClick={()=>setPropTab('sale')}>For Sale</button>
                            <button className={`ht-prop-tab${propTab==='rent'?' on':''}`} onClick={()=>setPropTab('rent')}>For Rent</button>
                        </div>
                    </div>
                    <div className="ht-prop-grid">
                        {filteredProps.map(p=>(
                            <div key={p.title} className="ht-pc">
                                <div className="ht-pc-head">
                                    {p.tag ? <span className="ht-pc-badge">{p.tag}</span> : <span/>}
                                    <span className="ht-pc-arr">↗</span>
                                </div>
                                <p className="ht-pc-loc">◎ {p.loc}</p>
                                <h3 className="ht-pc-title">{p.title}</h3>
                                <div className="ht-pc-div"/>
                                <p className="ht-pc-price">{p.price}</p>
                                <div className="ht-pc-meta">
                                    {[{l:'Beds',v:p.beds},{l:'Baths',v:p.baths},{l:'Sqft',v:p.area}].map(m=>(
                                        <div key={m.l} className="ht-pc-meta-item">
                                            <span className="ht-pc-meta-v">{m.v}</span>
                                            <span className="ht-pc-meta-l">{m.l}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="ht-svc-cta-row" style={{marginTop:'2.5rem'}}>
                        <button className="ht-dark-btn" onClick={()=>go(propTab==='sale'?'/sale':'/rent')}>
                            View All {propTab==='sale'?'Sale':'Rental'} Listings ↗
                        </button>
                    </div>
                </div>
            </section>
            <Contact/>
            {/* ══ GOLD CTA BANNER ══ */}
            <section className="ht-cta">
                <div className="ht-cta-inner">
                    <div>
                        <h2 className="ht-cta-h">Ready to Find Your<br/><em>Perfect Property?</em></h2>
                        <p className="ht-cta-p">
                            Whether buying, selling, leasing, or investing — our expert team is ready to deliver
                            transparent, professional guidance tailored to your goals.
                        </p>
                    </div>
                    <button className="ht-cta-btn" onClick={()=>go('/contact')}>
                        Get a Free Consultation ↗
                    </button>
                </div>
            </section>
        </>
    );
};
export default Hero;